import request from '@/utils/request'


// 查询调查问卷选项列表
export function listSurveyOption(query) {
  return request({
    url: '/biz/survey-option/list',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项分页
export function pageSurveyOption(query) {
  return request({
    url: '/biz/survey-option/page',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项详细
export function getSurveyOption(data) {
  return request({
    url: '/biz/survey-option/detail',
    method: 'get',
    params: data
  })
}

// 新增调查问卷选项
export function addSurveyOption(data) {
  return request({
    url: '/biz/survey-option/add',
    method: 'post',
    data: data
  })
}

// 修改调查问卷选项
export function updateSurveyOption(data) {
  return request({
    url: '/biz/survey-option/edit',
    method: 'post',
    data: data
  })
}

// 删除调查问卷选项
export function delSurveyOption(data) {
  return request({
    url: '/biz/survey-option/delete',
    method: 'post',
    data: data
  })
}
